<div class="navigation__container" (click)="goBack()">
  <div class="navigation__arrow-container">
    <fa-icon class="card-button__icon" [icon]="['fas', 'arrow-left']"></fa-icon>
  </div>
  <div class="navigation__page-name">
    <span>{{ pageName }}</span>
  </div>
</div>
